import { webClient } from "@shared/apis"
import { Pagination } from "@shared/types"

export default {
  post: (content: string, nickname: string, scheduleId: number) =>
    webClient.post(`/counsels`, {
      content,
      nickname,
      scheduleId,
    }),
  get: (
    scheduleId?: string | number | undefined,
    nickname?: string | undefined,
    page = 1,
    size = 10,
  ) =>
    webClient.get<Pagination<Counsel>>(`/counsels`, {
      params: { scheduleId, nickname, page, size },
    }),
}

export interface Counsel {
  content: string
  createdAt: string
  id: number
  nickname: string
  scheduleId: number
  updatedAt: string
}
